/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import { withRouter } from 'react-router-dom'
import { isEmpty } from 'lodash'
import usePrevious from '../hooks/usePrevious'

import SidebarModal from './SidebarModal'
import TabOrderItems from './tabs/TabOrderItems'
import Button from './Button'
import ConfirmSplitPaymentDialog from './dialog/ConfirmSplitPaymentDialog'

import { USE_RICH_CHECKOUT } from '../constants'

import styles from './CartModal.module.scss'

const CartModal = ({ history, hasCartItems, clearCart, className, cartItems, onSelectItem, total, taxRate, totalAfterTax, itemCount, discountsAvailable, discounts, onRemove, noOpPayments, signatureRequired, tipSuggestions, placeFreeOrder, cashEnabled, networkAvailable, ticketEnabled }) => {
  const classNames = cn(styles.cartModal, className)
  const [showCart, setShowCart] = useState(false)
  const [showSplitPayDialog, setShowSplitPayDialog] = useState(false)

  const prevCartItems = usePrevious(cartItems)
  const buttonsDisabled = !hasCartItems
  const discountSelected = !isEmpty(discounts)
  const richCheckoutAvailable = USE_RICH_CHECKOUT === 'true'

  useEffect(() => {
    if (prevCartItems && !isEmpty(prevCartItems) && isEmpty(cartItems)) {
      setShowCart(false)
    }
  }, [cartItems]);

  const handleCardTransaction = () => {
    if (signatureRequired || !isEmpty(tipSuggestions)) {
      history.push('/signature')
    } else {
      history.push('/card-reader')
    }
  }

  const trueExtraButtonCount = !!cashEnabled +
   !isEmpty(noOpPayments) +
   !!discountsAvailable +
   !!richCheckoutAvailable +
   !!networkAvailable + ticketEnabled

  let extraButtonCount
  if (trueExtraButtonCount > 3) {
    extraButtonCount = 3
  } else {
    extraButtonCount = trueExtraButtonCount
  }

  const extraButtonClassName = cn([styles.checkout, extraButtonCount === 1 ? styles.long : styles.short])
  const showOtherButton = trueExtraButtonCount > 3 
  

  let buttons = [
    <Button
      className={cn([styles.checkout, extraButtonCount < 3 ? styles.long : styles.short])}
      disabled={buttonsDisabled}
      onClick={handleCardTransaction}
    >
      {"Card"}
    </Button>
  ]
  
  if (cashEnabled) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={() => history.push('/change-calculator')}
      >
      {"Cash"}
    </Button>)
  }

  if (discountsAvailable) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={() => history.push('/concession-order/select-discount')}
    >{"Discount"}</Button>)
  }
  
  if ((buttons.length < 3 || (buttons.length < 4 && !showOtherButton)) && richCheckoutAvailable) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={() => history.push('/rich-checkout')}
    >{"App"}</Button>)
  }
  
  
  if ((buttons.length < 3 || (buttons.length < 4 && !showOtherButton)) && ticketEnabled) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={() => {
        if (!isEmpty(tipSuggestions)) {
          history.push({
            pathname: '/signature',
            state: {
              addTipThenRedirectPath: '/ticket'
            }
          })
        } else {
          history.push('/ticket')
        }
      }}
      >
      Ticket
    </Button>)
  }
  
  if ((buttons.length < 3 || (buttons.length < 4 && !showOtherButton)) && networkAvailable) {
    buttons.push(<Button
      className={extraButtonClassName}
      onClick={() => setShowSplitPayDialog(true)}
    >
     Split
    </Button>)
  }
  
  if (showOtherButton || (buttons.length < 4 && !isEmpty(noOpPayments))) {
    buttons.push(
      <Button
        className={extraButtonClassName}
        onClick={() => history.push("/tender-selection")}
      >
        Other
      </Button>
    );
  }
  

  let modal = null

  if (showSplitPayDialog) {
    modal = (
      <ConfirmSplitPaymentDialog
        onClose={() => setShowSplitPayDialog(false)}
        fromConcessions={true}
      />
    )
  }

  const Cart = () => (
    <>
    <SidebarModal
      show={showCart}
      title='New Order'
      className={styles.cart}
      onClose={() => setShowCart(false)}
      isShowClear={true}
      clearCart={clearCart}
    >
      <div className={styles.bodyContainer}>
        <TabOrderItems
          className={styles.itemsContainer}
          items={cartItems}
          onSelectItem={(index) => onSelectItem(index)}
          onRemove={onRemove}
        />
        <div className={styles.tabOrderTotals}>
          <div className={styles.row}>
            <span className={styles.rowHeader}>Subtotal ({itemCount})</span>
            <span>{total}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.rowHeader}>Sales Tax</span>
            <span>{taxRate}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.rowHeader}>Total</span>
            <span>{totalAfterTax}</span>
          </div>
          <div className={styles.row}>
            {discountSelected && <span className={styles.discount}>Discount applied upon checkout</span>}
          </div>
        </div>
        <div className={styles.buttonContainer}>{buttons}</div>
      </div>
    </SidebarModal>
    </>
  )
  
  return (
    hasCartItems && (
      <div className={classNames}>
        <Button
          className={styles.showCartButton}
          onClick={() => setShowCart(true)}
        >
          <span className={styles.quantity}>{itemCount}</span>
          <span className={styles.title}>View Cart</span>
          <span className={styles.total}>{total}</span>
        </Button>
        <Cart />
        {modal}
      </div>
    )
  )
}

export default withRouter(CartModal)
